import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { useInterval } from "../../hooks/useInterval";

//change the value below if you want to give user more or less time to click on Stay
//WARNING: If you are changing to anything other than 100
// Add logic to handle normalizing the number
const TIMEOUT_DELAY = 100;

const TimeoutDialog = (props) => {
  const [counter, setCounter] = useState(TIMEOUT_DELAY);

  useInterval(function countDown() {
    setCounter((prevCounter) =>
      prevCounter <= 0 ? props.quit() : prevCounter - 1
    );
  }, 1000);

  // Prevent accidental dismissal - user must click a button.
  // v9 removed `disableEscapeKeyDown`, so Escape now reaches onClose; ignore
  // both backdrop and Escape so the dialog stays open unless a button is used.
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      props.quit();
    }
  };

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="timeout-dialog-title"
      aria-describedby="timeout-dialog-description">
      <DialogTitle id="timeout-dialog-title">
        Do you want to stay logged in?
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="timeout-dialog-description"
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        ></DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.quit} variant="outlined" color="secondary">
          Quit
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={props.refreshToken}
          autoFocus
          startIcon={
            <CircularProgress
              variant="determinate"
              value={counter}
              thickness={5}
              color={counter < 25 ? "secondary" : "primary"}
              size={20}
            />
          }
        >
          Stay Logged in
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TimeoutDialog;
